module.exports = __webpack_public_path__ + "static/media/left-thin-arrow.79476458.svg";